<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmnote.list.filters.idCase') }}:</label>
            <el-select
                    v-model="filters.idCase"
                    multiple
                    filterable
                    remote
                    reserve-keyword
                    placeholder=""
                    :remote-method="remoteMethod"
                    :loading="loading">
              <el-option
                      v-for="item in cases"
                      :key="item['@id']"
                      :label="item.title"
                      :value="item['@id']">
              </el-option>
            </el-select>
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmnote.list.filters.title') }}:</label>
            <input v-model.lazy="filters.title" v-debounce="delay" class="form-control" type="text" placeholder="">
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmnote.list.filters.state') }}:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="filters.state"
                :options="radioOptions"
                buttons
                button-variant="outline-primary"
                name="radios-btn-default"
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import debounce from 'v-debounce'
import getId from '@/utils/getIdFromLink'
export default {
  name: 'NotesFiltering',

  props: {
    getPage: {
      type: Function,
      required: true
    }
  },

  data () {
    return {
      yesAndNoOptions: [
        {
          value: 0,
          text: this.$t('buttons.no')
        },
        {
          value: 1,
          text: this.$t('buttons.yes')
        }
      ],
      radioOptions: [
        {
          value: 1,
          text: this.$t('buttons.no')
        },
        {
          value: 0,
          text: this.$t('buttons.yes')
        }
      ],
      delay: 500,
      filters: {
        title: '',
        idCase: [],
        state: 1
      },
      cases: [],
      loading: false
    }
  },

  directives: {
    debounce
  },

  watch: {
    'filters.title': function () {
      this.filter()
    },
    'filters.idCase': function () {
      this.filter()
    },
    'filters.note': function () {
      this.filter()
    },
    'filters.state': function () {
      this.filter()
    }
  },

  created () {
    this.getCases()
  },

  methods: {
    filter () {
      let url = 'e_x_c_m_notes?_page=1'
      url += '&state=' + this.filters.state
      if (this.filters.title) {
        url += '&title=' + this.filters.title
      }
      if (this.filters.idCase.length > 0) {
        for (let i in this.filters.idCase) {
          url += '&idCase[]=' + this.getIdLink(this.filters.idCase[i])
        }
      }
      this.getPage(url)
    },
    getCases () {
      let params = {
        'pagination': false,
        'state': 1
      }
      this.cases = []
      this.$http.get('api/e_x_c_m_cases', {
        params
      })
        .then(response => {
          this.cases = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    remoteMethod () {
      // console.log()
    },
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
